import { Component, OnInit } from '@angular/core';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ClientCornerHomePageInpressWorkerControllerRequestService } from './service/client-corner-home-page-inpress-workers-controller-request.service';
import {
  ClientCornerHomePageInpressWorkerHelper,
  InpressWorkerDisplay,
} from './helper/client-corner-home-page-inpress-workers-helper';

@Component({
  selector: 'client-corner-home-page-inpress-workers',
  templateUrl: './client-corner-home-page-inpress-workers.component.html',
  styleUrls: ['./client-corner-home-page-inpress-workers.component.scss'],
})
export class ClientCornerHomePageInpressWorkersComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  workers: InpressWorkerDisplay[];

  constructor(
    private clientCornerHomePageInpressWorkerRequestControllerService: ClientCornerHomePageInpressWorkerControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.workers =
      ClientCornerHomePageInpressWorkerHelper.initializeInpressWorkers();
    this.getWorkerProfilePictures();
  }

  private getWorkerProfilePictures(): void {
    this.workers.forEach(async (w) => {
      const profilePicture =
        await this.clientCornerHomePageInpressWorkerRequestControllerService.profilePicture(
          w.userEmailAddress
        );
      if (profilePicture != null) {
        w.profilePictureUrl = `/api/assets/${profilePicture.uuid}`;
      }
    });
  }
}
